import { createFileRoute, redirect } from '@tanstack/react-router'
import * as z from 'zod'

// Legacy route — the "Витрати матеріалів" report is now the `consumption` view of
// /reports/stock-movements. Redirect (forwarding any filters in the URL) so old
// bookmarks keep working. Passthrough schema keeps every incoming query param.
const SearchSchema = z.object({}).passthrough()

export const Route = createFileRoute('/_app/reports/material-consumption')({
  validateSearch: SearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/reports/stock-movements/',
      search: { ...search, view: 'consumption' },
    })
  },
})
